import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Badge,
  Button
} from '@tonic/shared/components/ui';
import { Plus, ArrowUpRight, ArrowDownRight } from 'lucide-react';

export function RentalOverviewPage() {
  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Rental Overview</h1>
          <p className="text-sm text-neutral-500">Monitor rental program performance</p>
        </div>
        <Button>
          <Plus className="w-4 h-4 mr-2" />
          New Rental
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Active Rentals</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">156</div>
            <div className="flex items-center text-sm text-green-500">
              <ArrowUpRight className="w-4 h-4 mr-1" />
              <span>12% from last month</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Available Items</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">89</div>
            <div className="flex items-center text-sm text-red-500">
              <ArrowDownRight className="w-4 h-4 mr-1" />
              <span>4% from last month</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Monthly Revenue</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">$12,450</div>
            <div className="flex items-center text-sm text-green-500">
              <ArrowUpRight className="w-4 h-4 mr-1" />
              <span>15% from last month</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Active Customers</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">245</div>
            <div className="flex items-center text-sm text-green-500">
              <ArrowUpRight className="w-4 h-4 mr-1" />
              <span>8% from last month</span>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Additional sections like charts and tables can be added here */}
    </div>
  );
} 